import FeatureText from './FeatureText';

export default FeatureText;
